export default "https://cdn-static.gokick.com/assets/3eb3f200054f2a6c9c5d0f37afa2d1dee3c44d6a/images/spearmint-flavor.4c44d265d2ca14e44f653db82c437465.png";